import { defineNuxtPlugin } from '#app';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { configureLogger } from '~/utils/logger';

export default defineNuxtPlugin((nuxtApp) => {
    const {
        ddApplicationId,
        ddApplicationToken,
        ddEnv,
        ddVersion,
        ddBranch,
        commitHash,
        commitDate,
        buildDate,
        vercelDeploymentUrl,
        vercelBranchUrl,
        vercelProductionUrl,
    } = nuxtApp.$config.public;
    const logsSessionSampleRate = ddEnv === 'dev' ? 100 : 30;

    configureLogger({
        env: ddEnv,
        service: 'live-instant-rips-ui',
    });

    if (ddApplicationId && ddApplicationToken) {
        const deploymentContext = {
            git: {
                branch: ddBranch || 'unknown',
                commit: commitHash || 'unknown',
                commitDate: commitDate || 'unknown',
            },
            build: {
                version: ddVersion,
                date: buildDate || 'unknown',
            },
            vercel: {
                deploymentUrl: vercelDeploymentUrl || undefined,
                branchUrl: vercelBranchUrl || undefined,
                productionUrl: vercelProductionUrl || undefined,
            },
        };

        datadogRum.init({
            applicationId: ddApplicationId,
            clientToken: ddApplicationToken,
            site: 'datadoghq.com',
            service: 'live-instant-rips-ui',
            env: ddEnv,
            version: ddVersion,
            sessionSampleRate: 30,
            sessionReplaySampleRate: 20,
            defaultPrivacyLevel: 'mask-user-input',
        });
        datadogRum.setGlobalContextProperty('deployment', deploymentContext);
        datadogRum.startSessionReplayRecording();
        datadogLogs.init({
            clientToken: ddApplicationToken,
            site: 'datadoghq.com',
            service: 'live-instant-rips-ui',
            env: ddEnv,
            version: ddVersion,
            forwardErrorsToLogs: true,
            sessionSampleRate: logsSessionSampleRate,
        });
        datadogLogs.setGlobalContextProperty('deployment', deploymentContext);

        configureLogger({
            datadogLogger: datadogLogs.logger,
        });
    }

    // Provide the initialized datadogRum instance
    return {
        provide: {
            datadogRum,
            datadogLogs,
        },
    };
});
